import Entity from "../../../class/abstract/Entity";

class DrawerEventEntry extends Entity {
    store = null;
    store_id = null;
    license = null;
    license_id = null;
    automaticDrawer = null;
    automatic_drawer_id = null;
    licenseReference = null;
    licenseName = null;
    sellerReference = null;
    sellerName = null;
    type = null;
    identifier = null;
    message = null;
    response = null;
    state = null;
    version = null;
    received_at = null;
    inventoryType = null;
    ready = null;
    toNotify = null;

    constructor(datas = {}) {
        super(datas)
        this.setAttributes(datas)
    }

    setAttributes(datas) {
        let keys = Object.keys(this)
        let key = ""

        for(let i in keys) {
            key = keys[i]

            if (datas[key] !== undefined) {
                Reflect.set(this, key, datas[key])
            }
        }
    }
}

export default DrawerEventEntry;
